const routes = [
    {
        path: "/",
        component: () => import("../App/Pages/Home.vue"),
        name: "home",
    },
    {
        path: "/par-mums",
        component: () => import("../App/Pages/About.vue"),
        name: "about",
    },
    {
        path: "/par-sikdatnem",
        component: () => import("../App/Pages/CookiesPolicy.vue"),
        name: "cookiesPolicy",
    },
    {
        path: "/par-projektu",
        component: () => import("../App/Pages/AboutProject.vue"),
        name: "aboutProject",
    },
    {
        path: "/lvda-2022",
        component: () => import("../App/Pages/Instruction.vue"),
        name: "instruction",
    },
    {
        path: "/kontakti",
        component: () => import("../App/Pages/Contacts.vue"),
        name: "contacts",
    },
    {
        path: "/privatuma-politika",
        component: () => import("../App/Pages/PrivacyAndTerms.vue"),
        name: "privacyAndTerms",
    },
    {
        path: "/paroles/atjaunosana/:token",
        component: () => import("../Admin/Pages/PasswordReset.vue"),
        name: "passwordReset",
    },
    {
        path: "/paroles-atjaunosanas-pieprasijums",
        component: () => import("../Admin/Pages/SendResetPasswordLink.vue"),
        name: "sendResetPasswordLink",
    },
    {
        path: "/epasta/apstiprinasana/:id/:hash",
        component: () => import("../Admin/Pages/EmailVerification.vue"),
        name: "emailVerification",
    },
    {
        path: "/lietotajs-apstiprinats",
        component: () => import("../Admin/Pages/UserApproved.vue"),
        name: "userApproved",
    },
    {
        path: "/interaktiva-karte",
        component: () => import("../App/Pages/Map.vue"),
        name: "geoMap",
    },
    {
        path: "/lietotaja-konts",
        component: () => import("../Admin/Pages/UserProfile.vue"),
        name: "userProfile",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ielogoties",
        component: () => import("../Admin/Pages/Login.vue"),
        name: "login",
    },
    {
        path: "*",
        component: () => import("../Shared/Pages/PageNotFound.vue"),
        name: "pageNotFound",
    },

    //admin
    {
        path: "/administracija/sakums",
        component: () => import("../Admin/Pages/AdminHome.vue"),
        name: "adminHome",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/administracija/karte/:id?",
        component: () => import("../Admin/Pages/CreateUpdateMap.vue"),
        name: "createUpdateMap",
        meta: {
            requiresAuth: true,
        },
    },
];

export default routes;
